import { initialize, trackEvent } from './google-analytics';

export { initialize, trackEvent };

export default { initialize };
